// TODO: refactor with PlusPlusPlus and ErrorRecord utils in cannery shared utils
const MinErrorCodeLen = 3;
export function normalizeError(err) {
    if (!err) {
        err = {};
    }
    else if (err instanceof Error) {
        const errRecord = {};
        Object.getOwnPropertyNames(err).forEach((k) => {
            errRecord[k] = err[k];
        });
        err = errRecord;
        const errorMessageAsErrorCode = err.message && err.message.startsWith('Error: ') && err.message.length >= MinErrorCodeLen + 7 ?
            err.message.slice(7) :
            err.message;
        if (_looksLikeErrorCode(errorMessageAsErrorCode)) {
            err.errorCode = errorMessageAsErrorCode;
            delete err.message;
        }
    }
    else if (typeof err !== 'object') {
        if (typeof err.toString === 'function') {
            let reason = err.toString();
            if (_looksLikeErrorCode(reason)) {
                err = { errorCode: reason };
            }
            else {
                err = { reason };
            }
        }
        else {
            err = {};
        }
    }
    else if (_isPlusPlusPlus(err)) {
        err = err.dataWithInternalInfo(); // or switch to extData() ?  
    }
    else {
        err = _extractErrorRecord(err);
    }
    err.errorCode = err.errorCode || 'ErrorInRpcResponse'; // todo: to central RpcErrorCode
    return err;
}
function _looksLikeErrorCode(val) {
    if (!val || typeof val !== 'string') {
        return false;
    }
    const len = val.length;
    return len > 2 && len <= 256 && !val.includes(' ');
}
function _isPlusPlusPlus(obj) {
    return obj.isPlusPlusPlus && typeof obj.dataWithInternalInfo === 'function';
}
function _extractErrorRecord(obj) {
    const { errorCode, message, stack, reason, details, rpcInfo, remoteMethodName } = obj;
    return { errorCode, reason, message, remoteMethodName, stack, details, rpcInfo };
}
//# sourceMappingURL=error-record-util.js.map